// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3kPr8","copyright":"Footer_copyright__3sHM8"};